import useLanguage from '@/hooks/useLanguage';
import { IconArrowDownFull } from '@/theme/icons';
import rem from '@/utils/rem';
import { Button, Heading, Icon, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

interface LanguageSelectorProps {
  showLabel?: boolean;
}

const LanguageSelector = ({ showLabel = true }: LanguageSelectorProps) => {
  const { t } = useTranslation('LanguageSelector');
  const { currentLanguage, changeLanguage, availableLanguages } = useLanguage();

  const handleLanguageChange = useCallback(
    (newLanguage: string) => {
      changeLanguage(newLanguage as 'en' | 'es');
    },
    [changeLanguage],
  );

  return (
    <>
      <Menu>
        {showLabel && <Heading fontSize="lg">{t('settings.language')}</Heading>}
        <MenuButton as={Button} marginBottom={rem(10)} rightIcon={<Icon as={IconArrowDownFull} boxSize={rem(7)} />}>
          {t(`languageOptions.${currentLanguage}`)}
        </MenuButton>
        <MenuList>
          {availableLanguages.map((lang) => (
            <MenuItem key={lang} onClick={() => handleLanguageChange(lang)}>
              {t(`languageOptions.${lang}`)}
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </>
  );
};

export default LanguageSelector;
